import { render, staticRenderFns } from "./DialectRequestModal.vue?vue&type=template&id=20a878d8&scoped=true&"
import script from "./DialectRequestModal.vue?vue&type=script&lang=js&"
export * from "./DialectRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./DialectRequestModal.vue?vue&type=style&index=0&id=20a878d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a878d8",
  null
  
)

export default component.exports